export const applySoftScale = (value, max) => {
  if (value == null || value === 0) return null;
  if (!Number.isFinite(max) || max <= 0) return value;
  const minVisualFactor = 0.2;
  return (value / max) * (1 - minVisualFactor) + minVisualFactor;
};

export const applyBarSoftScale = (datasets, data) => {
  const maxValue = data.reduce((max, month) =>
    Object.values(month.groups).reduce((groupMax, group) =>
      Math.max(groupMax, group.volume ?? 0), max), 0);

  return datasets.map((dataset) => dataset.type === 'line' ? dataset : {
    ...dataset,
    minBarLength: 20,
    originalData: dataset.data,
    data: dataset.data.map((value) => {
      const scaled = applySoftScale(value, maxValue);
      return scaled == null ? null : scaled * maxValue;
    }),
  });
};
